// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");
let MyClientsWidgetRelayPaginationQuery_graphql = require("./MyClientsWidgetRelayPaginationQuery_graphql.bs.js");

let Types = {};

function unwrap_fragment_accountClientsV5_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "Buyer",
    "Landlord",
    "Renter",
    "Seller"
  ]);
}

let fragmentConverter = {"__root":{"accountClientsV5_edges_node_Seller":{"f":""},"accountClientsV5_edges_node_Renter":{"f":""},"accountClientsV5_edges_node_Landlord":{"f":""},"accountClientsV5_edges_node_Buyer":{"f":""},"accountClientsV5_edges_node":{"u":"fragment_accountClientsV5_edges_node"}}};

let fragmentConverterMap = {
  fragment_accountClientsV5_edges_node: unwrap_fragment_accountClientsV5_edges_node
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId, searchTerm) {
  let args = {
    searchTerm: searchTerm
  };
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "MyClientsWidgetRelayQuery_accountClientsV5", args);
}

function getConnectionNodes(connection) {
  if (connection === undefined) {
    return [];
  }
  let edges = connection.edges;
  if (edges !== undefined) {
    return Stdlib_Array.filterMap(edges, edge => {
      if (edge !== undefined) {
        return edge.node;
      }
    });
  } else {
    return [];
  }
}

let Utils = {
  getConnectionNodes: getConnectionNodes
};

function makeNode(rescript_graphql_node_MyClientsWidgetRelayPaginationQuery) {
  return ((function(){
var v0 = [
  "accountClientsV5"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchTerm"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": rescript_graphql_node_MyClientsWidgetRelayPaginationQuery
    }
  },
  "name": "MyClientsWidgetRelay_query",
  "selections": [
    {
      "alias": "accountClientsV5",
      "args": [
        {
          "kind": "Variable",
          "name": "__dynamicKey",
          "variableName": "viewId"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        }
      ],
      "concreteType": "QueryClientV5Connection",
      "kind": "LinkedField",
      "name": "__MyClientsWidgetRelayQuery_accountClientsV5_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueryClientV5Edge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v1/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MyClientsWidgetLandlord_landlord"
                    }
                  ],
                  "type": "Landlord",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v1/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MyClientsWidgetSeller_seller"
                    }
                  ],
                  "type": "Seller",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v1/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MyClientsWidgetBuyer_buyer"
                    }
                  ],
                  "type": "Buyer",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v1/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MyClientsWidgetRenter_renter"
                    }
                  ],
                  "type": "Renter",
                  "abstractKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})());
}

let node = makeNode(MyClientsWidgetRelayPaginationQuery_graphql.node);

let wrap_fragment_accountClientsV5_edges_node = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_accountClientsV5_edges_node = unwrap_fragment_accountClientsV5_edges_node;
exports.wrap_fragment_accountClientsV5_edges_node = wrap_fragment_accountClientsV5_edges_node;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
